/** ePSF workspace categories: Home, IMP ledger, Operations, Evidence (binder suite). */

export const EPSF_WORKSPACE_GROUPS = [
  {
    id: "imp-setup",
    title: "IMP setup",
    shortTitle: "Setup",
    items: [
      {
        id: "products",
        title: "IMP Products",
        shortTitle: "Products",
        path: "/epsf/imp/products",
        icon: "fas fa-capsules",
        description: "Organisation IMP product catalogue.",
        permissionKeys: ["EPSF_IMP_PRODUCT_MANAGE"],
      },
      {
        id: "sponsor-setup",
        title: "Treatment setup",
        shortTitle: "Treatment",
        path: "/epsf/imp/sponsor-setup",
        icon: "fas fa-user-shield",
        description: "Restricted: assign ACTIVE / PLACEBO / COMPARATOR to study products.",
        restricted: true,
        permissionKeys: ["EPSF_TREATMENT_SETUP"],
      },
      {
        id: "kit-mapping",
        title: "Kit mapping",
        shortTitle: "Kits",
        path: "/epsf/imp/kit-mapping",
        icon: "fas fa-barcode",
        description: "Restricted: map Individual Kit numbers to study treatment.",
        restricted: true,
        permissionKeys: ["EPSF_KIT_TREATMENT_MANAGE"],
      },
    ],
  },
  {
    id: "imp-ledger",
    title: "IMP ledger",
    shortTitle: "Ledger",
    items: [
      {
        id: "inventory",
        title: "Inventory",
        shortTitle: "Inventory",
        path: "/epsf/imp/inventory",
        icon: "fas fa-boxes",
        primary: true,
        description: "On-hand balance by product and batch.",
        permissionKeys: [
          "EPSF_INVENTORY_VIEW",
          "EPSF_RECEIVE",
          "EPSF_DISPENSE",
          "EPSF_RETURN",
          "EPSF_RECONCILE",
          "EPSF_DESTROY",
          "EPSF_RELEASE",
        ],
      },
      {
        id: "receipt",
        title: "Receive",
        shortTitle: "Receive",
        path: "/epsf/imp/receipt",
        icon: "fas fa-truck-loading",
        primary: true,
        description: "Record IMP shipments: batch, expiry, quantity.",
        permissionKeys: ["EPSF_RECEIVE"],
      },
      {
        id: "storage",
        title: "Storage & temperature",
        shortTitle: "Storage",
        path: "/epsf/imp/storage",
        icon: "fas fa-thermometer-half",
        description: "Storage units, temperature logs, and excursions.",
        permissionKeys: [
          "EPSF_INVENTORY_VIEW",
          "EPSF_RECEIVE",
        ],
      },
      {
        id: "dispense",
        title: "Dispense",
        shortTitle: "Dispense",
        path: "/epsf/imp/dispense",
        icon: "fas fa-hand-holding-medical",
        primary: true,
        description: "Dispense IMP to participants or kits.",
        permissionKeys: ["EPSF_DISPENSE"],
      },
      {
        id: "returns",
        title: "Returns",
        shortTitle: "Returns",
        path: "/epsf/imp/returns",
        icon: "fas fa-undo",
        description: "Participant returns and stock returns to depot.",
        permissionKeys: ["EPSF_RETURN"],
      },
      {
        id: "accountability",
        title: "Reconcile",
        shortTitle: "Reconcile",
        path: "/epsf/imp/accountability",
        icon: "fas fa-balance-scale",
        description: "Expected vs physical count and compliance.",
        permissionKeys: ["EPSF_RECONCILE"],
      },
      {
        id: "destruction",
        title: "Destruction",
        shortTitle: "Destroy",
        path: "/epsf/imp/destruction",
        icon: "fas fa-trash-alt",
        description: "Destruction records and certificates.",
        permissionKeys: ["EPSF_DESTROY"],
      },
    ],
  },
  {
    id: "ops",
    title: "Operations",
    shortTitle: "Ops",
    items: [
      {
        id: "due-forms",
        title: "Due forms",
        shortTitle: "Due Forms",
        path: "/epsf/forms",
        icon: "fas fa-clipboard-list",
        description: "Runtime queue of forms due for completion and review.",
        permissionKeys: ["EPSF_EVIDENCE"],
      },
      {
        id: "form-requirements",
        title: "Form requirements",
        shortTitle: "Form setup",
        path: "/epsf/form-requirements",
        icon: "fas fa-cogs",
        description: "Configure event, recurring, and manual form requirements.",
        permissionKeys: ["EPSF_EVIDENCE"],
      },
      // Temporarily hidden from rail: Readiness, Digital DoA, Inspection & recall
    ],
  },
  {
    id: "evidence",
    title: "Evidence",
    shortTitle: "Evidence",
    items: [
      {
        id: "binder",
        title: "Binder",
        shortTitle: "Binder",
        path: "/epsf/binder",
        icon: "fas fa-folder-open",
        description: "Controlled pharmacy evidence repository.",
        evidence: true,
        permissionKeys: ["EPSF_EVIDENCE", "EPSF_BINDER_VIEW", "EPSF_BINDER_UPLOAD"],
      },
      {
        id: "folder-library",
        title: "Folder library",
        shortTitle: "Folders",
        path: "/epsf/folder-library",
        icon: "fas fa-folder",
        description: "Legacy eISF-style folder library (ePSF category).",
        evidence: true,
        permissionKeys: ["EPSF_EVIDENCE"],
      },
      // Temporarily hidden from rail: Miles, Plan, Templates
    ],
  },
];

/** Flat list used by workspace cards / legacy ImpSubNav. */
export const IMP_NAV_ITEMS = EPSF_WORKSPACE_GROUPS.filter((g) =>
  ["imp-setup", "imp-ledger", "ops", "evidence"].includes(g.id),
).flatMap((g) => g.items);

/** Evidence binder route inside ePSF workspace (reuses ISF engine, ePSF only). */
export const EPSF_EVIDENCE_PATH = "/epsf/binder";
